import * as React from 'react';

const AppFooter = () => (
    <footer className="container">
        <p className="float-right">
            <a href="#">Back to top</a>
        </p>
        <p>
            &copy; 2019-2029 Proenza, Raul Inc. &middot; <a href="#">Privacy</a> &middot;{' '}
            <a href="#">Terms</a>
        </p>
    </footer>
);

export default AppFooter;



// WEBPACK FOOTER //
// ./src/components/AppFooter.tsx